import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propBool, propFunc, propNumber, propShape, } from '../../../../helpers/custom-prop-types';
import Image from '../../Common/Image';
import SlideSearchItemCheckbox from '../../SlideSearch/Input/SlideSearchItemCheckbox';
const SlideViewerLeftComponentImage = (props) => {
    const { canCheck, checked, imageIndex, index, onChangeSelectSlide, onClickImage, page, setRef, unit, } = props;
    return (_jsx("div", Object.assign({ className: 'slide_viewer_left_image_box', "data-index": index, ref: setRef }, { children: _jsxs("div", Object.assign({ className: clsx('slide_viewer_left_image', {
                is_active: index === imageIndex,
            }), "data-value": index, onClick: onClickImage, role: 'presentation' }, { children: [canCheck && (_jsx(SlideSearchItemCheckbox, { checked: checked, className: 'slide_viewer_left_checkbox is_half', item: page, onChange: onChangeSelectSlide, unit: unit, uuid: page.id })), _jsx(Image, { allowContextMenu: false, alt: '', className: 'slide_viewer_left_image_tag', isObjectFitContain: true, src: page.image, useImage: true })] })) })));
};
SlideViewerLeftComponentImage.propTypes = {
    canCheck: propBool(),
    checked: propBool(),
    imageIndex: propNumber().isRequired,
    index: propNumber().isRequired,
    onChangeSelectSlide: propFunc(),
    onClickImage: propFunc().isRequired,
    page: propShape().isRequired,
    setRef: propFunc().isRequired,
    unit: propShape(),
};
SlideViewerLeftComponentImage.defaultProps = {
    canCheck: false,
    checked: false,
    onChangeSelectSlide: () => { },
    unit: null,
};
export default SlideViewerLeftComponentImage;
